<template>
    <div>
        <div class="d-flex flex-column align-items-center text-center bg-white pt-5 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
            <img alt="" :src="`/img/leads-gen-error.svg`" class="errorMessageIcon img-responsive">
            <span class="font-md font-weight-bold my-3">
                We have offers for you in our<br />partner stores!
            </span>
            <span class="font-sm text-secondary">
                You don&apos;t have available credit to pay for this online 
                <br />
                purchase. Don&apos;t worry! Contact us or visit the store
                <br />
                to find Home Credit offers that fit your needs.
            </span>
            <br />
            <button 
                type="button" 
                id="mobileSubmitBtn" 
                @click="shoppingMall" 
                class="btn btn-success rounded-lg font-sm text-capitalize font-weight-bold py-2 mt-3 mb-2 col-sm-10" 
                modalTrigger
            >Check Available Offers</button>
            <br />
            <back-to-store @click="backButton" v-if="!this.$root.$data.transaction.partnerId" class="pt-2">Back to Merchant</back-to-store>
            <back-to-store @click="backButton" v-else class="pt-5">Back to Merchant</back-to-store>
        </div>
    </div>
</template>
<script>
import { ERROR } from '../mixins/error_codes.js';

export default {
    data() {
        return {
            error: this.$root.error,
            downloadEventName: 'err_no_hc_acct_install_hc_app',
        }
    },
    created(){
        if(this.$root.transaction.page == "lazada") {
            this.transcation_type = "WT";
        } else {
            this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
        }
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.transcation_type,
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('err_no_hc_acct',g4params);
        this.$root.$data.previousView = 'not-available';
    },
    methods: {
        openSite(){
            window.location.href = "https://homecredit.ph/credit-card/";
        },
        websiteDirect() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_visit_website',g4params)
        },
        backButton() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_back_to_store',g4params)
        },
        shoppingMall() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_check_available_offers',g4params);
            const merchant = this.$root.$data.transaction.merchantName;
            let redirectUrl = "https://shop.shoppingmall.ph/download-home-credit-app-now";
            if (merchant) {
                redirectUrl = `${redirectUrl}?utm_source=dp_partner_${merchant}`;
            } else if (this.$root.transaction.page === "lazada") {
                redirectUrl = `${redirectUrl}?utm_source=dp_partner_Lazada`;
            }
            const encodedRedirect = encodeURI(redirectUrl);
            window.location.href = encodedRedirect;
        }
    }
}
</script>
<style scoped>
    .errorMessageIcon {
        height: auto;
        width: 9rem;
    }
    .paymentOptionCard {
        height: auto;
        width: 8rem;
    }
    .text-tertiary {
        color: #8C8C8C !important;
        margin-top: 1em;
    }
    .creditcardBg {
        background-color: #2196F3;
    }
    .walletpayBg {
        background-color: #009688;
    }
    .link-hc-site:hover{
        color: #49B672;
    }
</style>